module.exports = "<div class=\"row\">\n    <div class=\"col-md-12\">\n        {{copyright}}\n    </div>\n</div>"